import React from 'react';
import { motion } from 'framer-motion';
import { HiShieldCheck } from 'react-icons/hi';

const PrivacyPolicy = () => {
  return (
    <div className="relative bg-black min-h-screen text-white pt-32 pb-20 selection:bg-[#D4AF37]/30 selection:text-[#D4AF37] font-sans">
      <div className="absolute inset-0 z-0 overflow-hidden pointer-events-none">
          <div className="absolute top-0 right-[10%] w-[500px] h-[500px] bg-[#D4AF37]/5 blur-[120px] rounded-full" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="space-y-12"
        >
          <div className="text-center space-y-4">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-white/5 border border-[#D4AF37]/30 text-[#D4AF37] mb-4">
              <HiShieldCheck size={32} />
            </div>
            <h1 className="text-4xl md:text-5xl font-black tracking-tight">Privacy Policy</h1>
            <p className="text-zinc-400 font-semibold max-w-2xl mx-auto">
              Effective Date: {new Date().toLocaleDateString()} <br/>
              Your privacy is our priority at VisionCarePlus. This policy outlines how we collect, use, and protect your personal and medical information.
            </p>
          </div>

          <div className="space-y-8 bg-zinc-900/50 border border-white/5 p-8 md:p-12 rounded-3xl backdrop-blur-sm">
            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-[#D4AF37]">1. Information We Collect</h2>
              <p className="text-zinc-300 leading-relaxed">
                When you use VisionCarePlus, we may collect the following information:
              </p>
              <ul className="list-disc pl-6 text-zinc-400 space-y-2">
                <li>Personal identifiers (name, email address, phone number).</li>
                <li>Health and medical data (symptoms, preliminary screening results, and consultation records) voluntarily provided for tele-consultation.</li>
                <li>Usage data such as interaction with the platform and device information.</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-[#D4AF37]">2. How We Use Your Information</h2>
              <ul className="list-disc pl-6 text-zinc-400 space-y-2">
                <li>To provide, operate, and maintain our screening and consultation services.</li>
                <li>To process and route your preliminary symptom data to appropriate eye care professionals.</li>
                <li>To improve patient user experience through analytics.</li>
                <li>To communicate with you regarding appointments, follow-ups, or emergencies.</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-[#D4AF37]">3. Medical Data Security</h2>
              <p className="text-zinc-300 leading-relaxed">
                We implement industry-standard security measures designed to protect your medical information from unauthorized access or disclosure. However, no data transmission over the Internet can be guaranteed to be entirely secure. Our preliminary screening tool does not constitute a formal medical diagnosis or electronic health record.
              </p>
            </section>

             <section className="space-y-4">
              <h2 className="text-2xl font-bold text-[#D4AF37]">4. Sharing of Information</h2>
              <p className="text-zinc-300 leading-relaxed">
                We do not sell, trade, or rent your personal identification information to others. Information may be shared with our network of specialized eye clinics and government eye units solely for the purpose of facilitating your health care and consultations.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-[#D4AF37]">5. Contact Us</h2>
              <p className="text-zinc-300 leading-relaxed">
                If you have questions regarding this Privacy Policy, you can reach us at:
                <br />
                <span className="font-bold text-white">Email:</span> support@visioncare.com<br />
                <span className="font-bold text-white">Address:</span> 123 Vision Lane, Eye City, EC 5678
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
